// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ArrowDownLeftIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ArrowDownLeftIcon" ref={forwardedRef} {...props}>
      <path d="m5.855 14.153.007-8.5L7.364 5.65l-.005 5.88 5.586-5.586 1.059 1.059-5.648 5.647 6-.001-.001 1.495z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ArrowDownLeftIcon = /* @__PURE__ */ Object.assign(
  ArrowDownLeftIconComponent,
  { displayName: 'ArrowDownLeftIcon' },
);
